import { useBookDemo } from "./BookDemoModal";

export default function Hero() {
  const { openBookDemo } = useBookDemo();
  return (
    <section
      id="top"
      className="relative min-h-[600px] md:min-h-[720px] lg:min-h-[800px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="/hero-bg.jpg"
          alt="AI compliance technology background"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-24 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-xs md:text-sm font-medium mb-6 md:mb-8 animate-fade-in">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-count-pulse" />
            EU AI Act · Article 50 Transparency
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 md:mb-6 animate-fade-in-up">
            Mark every AI feature{" "}
            <span className="gradient-text">compliant</span> before the deadline
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-background-200/90 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed animate-fade-in-up" style={{ animationDelay: "0.15s" }}>
            EU AI Act Article 50 takes effect 2 August 2026. Every AI feature
            visible to EU users — chat, voice, translation, generated media,
            recommendations — must be disclosed and backed by evidence. Fines
            reach €15M or 3% of global revenue.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10 md:mb-12 animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
            <button type="button" onClick={openBookDemo} className="btn-primary text-base md:text-lg px-7 py-3.5">
              Book a demo
            </button>
            <a href="#how" className="btn-ghost text-base md:text-lg px-7 py-3.5 text-background-50 border-background-300/50 hover:bg-background-50/10">
              See how it works
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-background-300/80 animate-fade-in-up" style={{ animationDelay: "0.45s" }}>
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400" />
              Mapped to official Article 50 clauses
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400" />
              COMPL-AI model benchmarks included
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-check-line text-accent-400" />
              Deploys inside your infrastructure
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}